<div class="flex flex-col bg-surface mt-3">
  @if ({ empfaenger: filteredEmpfaneger$ | async }; as data) {
    @if ((loading$ | async) === false && (data.empfaenger?.length || 0) < 1) {
      @for (eintrag of suchverlauf$ | async; track eintrag) {
        <div
          class="bg-surface flex flex-col select-none cursor-pointer py-2 border-b border-b-solid"
        >
          <span class="font-semibold text-base px-4">{{ eintrag.text }}</span>
          <span class="font-normal text-lighter text-sm px-4">
            {{ eintrag.date | format: 'DATE.DEFAULT' }}
            {{ eintrag.date | format: 'TIME.DEFAULT' }}
          </span>
        </div>
      }
    } @else {
      @if ((loading$ | async) === false && (data?.empfaenger?.length || 0) > 0) {
        @for (
          empfaenger of data.empfaenger;
          track trackByFn($index, empfaenger);
          let last = $last
        ) {
          <div
            class="bg-surface flex items-center select-none cursor-pointer nowrap justify-between px-4 py-2 border-b-solid border-b"
            [ngClass]="[empfaenger?.selected ? 'bg-primary-100' : 'bg-surface']"
            (click)="selectOrUnselect(empfaenger)"
          >
            <div class="flex flex-col max-w-[calc(100%_2rem)]" style="min-width: 0">
              <h6 class="font-semibold text-base">
                {{ empfaenger?.vorname }} {{ empfaenger?.nachname }}
              </h6>
              @if (empfaenger?.kuerzel) {
                <span class="font-normal text-sm">{{ empfaenger?.kuerzel }}</span>
              }
            </div>
            <div class="flex items-center justify-center" style="width: 2rem">
              @if (empfaenger?.selected) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="currentColor"
                  class="w-5 h-5 text-primary"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4.5 12.75l6 6 9-13.5"
                  />
                </svg>
              }
            </div>
          </div>
        }
      } @else {
        <div class="flex flex-col gap-2 w-full">
          <div class="flex flex-col w-full skeleton h-16 p-2" *softRepeat="10"></div>
        </div>
      }
    }
    <ng-template #content>
      @if ((loading$ | async) === false && (data?.empfaenger?.length || 0) > 0) {
        @for (
          empfaenger of data.empfaenger;
          track trackByFn($index, empfaenger);
          let last = $last
        ) {
          <div
            class="bg-surface flex items-center select-none cursor-pointer nowrap justify-between px-4 py-2 border-b-solid border-b"
            [ngClass]="[empfaenger?.selected ? 'bg-primary-100' : 'bg-surface']"
            (click)="selectOrUnselect(empfaenger)"
          >
            <div class="flex flex-col max-w-[calc(100%_2rem)]" style="min-width: 0">
              <h6 class="font-semibold text-base">
                {{ empfaenger?.vorname }} {{ empfaenger?.nachname }}
              </h6>
              @if (empfaenger?.kuerzel) {
                <span class="font-normal text-sm">{{ empfaenger?.kuerzel }}</span>
              }
            </div>
            <div class="flex items-center justify-center" style="width: 2rem">
              @if (empfaenger?.selected) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2.5"
                  stroke="currentColor"
                  class="w-5 h-5 text-primary"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4.5 12.75l6 6 9-13.5"
                  />
                </svg>
              }
            </div>
          </div>
        }
      } @else {
        <div class="flex flex-col gap-2 w-full">
          <div class="flex flex-col w-full skeleton h-16 p-2" *softRepeat="10"></div>
        </div>
      }
    </ng-template>
  } @else {
    <div class="flex flex-col gap-2 w-full">
      <div class="flex flex-col w-full skeleton h-16 p-2" *softRepeat="10"></div>
    </div>
  }
</div>

<ng-template #header>
  <div class="flex pb-3 pt-6">
    <soft-input
      #input
      class="w-full h-10"
      placeholder="Empfänger suchen"
      [value]="input$ | async"
      (valueChange)="input$.next($event ?? null)"
    >
      @if ((input.value()?.length ?? 0) > 0) {
        <div
          class="cursor-pointer"
          [softToolTip]="'Suche zurücksetzen'"
          (click)="loadAllEmpfaenger(); onEmptyTextfield()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
      }
    </soft-input>
  </div>
</ng-template>

<ng-template #skeletonTemplate>
  <div class="flex flex-col gap-2 w-full">
    <div class="flex flex-col w-full skeleton h-16 p-2" *softRepeat="10"></div>
  </div>
</ng-template>
